import IResult from '../../../../shared/models/result/IResult';
import { SpanishLineWarningProps } from '../../services/spanishLineSetup';
import * as yup from 'yup';
import { withFormik } from "formik";
import SparkTelephonyDetails from './SparkTelephonyDetails';
import { TelephonyDeploymentResponse } from '../../../../shared/models/telephonyDeployment/TelephonyDeploymentResponse';
import TelephonyDeploymentRequest from '../../../../shared/models/telephonyDeployment/TelephonyDeploymentRequest';
import { defaultVoice } from '../../../../shared/constants/sparkConstants/voices';
import { defaultTelephonyDeploymentSettings } from '../../../../shared/constants/telephonyConstants.tsx/defaultTelephonyDeploymentSettings';
import ApplicationModel from '../../../../shared/models/applications/api/ApplicationModel';

export interface SparkTelephonyDetailsProps extends SpanishLineWarningProps {
    selectedTelephonyDeployment: TelephonyDeploymentResponse
    allTelephonyDeployments?: TelephonyDeploymentResponse[]
    handleSubmitTelephonyForm: (phoneNumber: string, telephonyDeploymentRequest: TelephonyDeploymentRequest) => Promise<IResult<TelephonyDeploymentResponse>>
    isLoadingTelephonyDeployments: boolean
    loadTelephonyDeployments: () => void
    applicationId: string
    createTelephonyDeployment: (appId: string, request: TelephonyDeploymentRequest) => Promise<any>
    orgName?: string
    appName?: string
    assistantType?: string
    onMultilingualEnabled?: () => Promise<void>
    isOutboundEnabledOnAnyOtherDeployment?: boolean
    orgId?: string
    applicationsList?: ApplicationModel[]
    handleTransferPhoneNumber?: (phoneNumber: string, targetAppName: string) => Promise<boolean>
    applicationFeatureFlags?: FeatureFlagModel[]
}

export interface SparkTelephonyDetailsFormData {
    callRecordingEnabled: boolean
    ttsOptions: [{ ttsVoice: string, ttsProvider: string }]
    virtualNumber?: string
    useVirtualNumber?: boolean
    performLanguageDetection?: boolean
    dtmfTurnsToListen?: number
    addSpanishLine: boolean
}

const SparkTelephonyDetailsForm = withFormik<SparkTelephonyDetailsProps, SparkTelephonyDetailsFormData>({
    mapPropsToValues: (props) => ({
        callRecordingEnabled: props.selectedTelephonyDeployment?.callRecordingEnabled ?? false,
        ttsOptions: props.selectedTelephonyDeployment?.ttsOptions ?? defaultTelephonyDeploymentSettings.ttsOptions,
        virtualNumber: props.selectedTelephonyDeployment?.virtualNumber,
        performLanguageDetection: props.selectedTelephonyDeployment?.performLanguageDetection ?? defaultTelephonyDeploymentSettings.performLanguageDetection,
        dtmfTurnsToListen: props.selectedTelephonyDeployment?.dtmfTurnsToListen ?? defaultTelephonyDeploymentSettings.dtmfTurnsToListen,
        addSpanishLine: false
    }),
    validationSchema: yup.object().shape({
        callRecordingEnabled: yup.boolean().required(),
        ttsOptions: yup.object().required(),
        virtualNumber: yup.string().required().max(50),
        performLanguageDetection: yup.boolean(),
        dtmfTurnsToListen: yup.number().min(0, "Must be a number 0 or greater"),
        addSpanishLine: yup.boolean()
    }),
    handleSubmit: (values, { props, setSubmitting }) => {
        setSubmitting(true);
    }
})(SparkTelephonyDetails);

export default SparkTelephonyDetailsForm;
